import React from "react";
import { Home } from "lucide-react";

const ITEMS = [
  "Milano", "Roma", "Napoli", "Torino", "Firenze", "Bologna", "Venezia", "Bari", "Lecce",
  "Palermo", "Genova", "Verona", "zero spam", "100% gratuito", "La casa cerca te!",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative bg-[#0A192F] py-5 overflow-hidden" aria-hidden="true">
      <div className="flex w-max animate-marquee items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span
              className={`font-display text-lg sm:text-xl font-bold tracking-tight px-6 ${
                item === "La casa cerca te!" ? "text-[#10B981] italic" : "text-white/80"
              }`}
            >
              {item}
            </span>
            <Home className="w-3.5 h-3.5 text-emerald-500/60 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
